import { Trans } from '@lingui/react/macro'
import { Spinner } from 'designSystem/components/Spinner'
import { PreviewCitedTextOverlay } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewCitedTextOverlay'
import { PageImage } from 'features/knowledgeDocumentViewer/components/viewer/continuous/continuousScrollStyles'
import { usePdfAsImage } from 'features/knowledgeDocumentViewer/components/viewer/image/hooks/usePdfAsImage'

import type { WorkOrderTextRun } from './workOrderHighlights'
import { SHEET_HEIGHT, SHEET_WIDTH } from './workOrderSheet'
import { WorkOrderPageStatus } from './workOrderViewerStyles'

export function CmmsScrollPage({
  pdfUrl,
  page,
  totalPages,
  alt,
  highlights,
}: {
  pdfUrl: string
  page: number
  totalPages: number
  alt: string
  highlights: WorkOrderTextRun[]
}) {
  const image = usePdfAsImage(pdfUrl, page, 2, totalPages, true, {
    preloadAdjacentPages: false,
  })
  if (image.error)
    return (
      <WorkOrderPageStatus role='alert'>
        <Trans>Could not display this page. Try downloading the PDF.</Trans>
      </WorkOrderPageStatus>
    )
  if (!image.imageUrl || image.stale)
    return (
      <WorkOrderPageStatus role='status'>
        <Spinner />
      </WorkOrderPageStatus>
    )
  return (
    <>
      <PageImage src={image.imageUrl} alt={`${alt} (${page}/${totalPages})`} />
      <PreviewCitedTextOverlay
        boxes={highlights
          .filter((run) => run.page === page)
          .map((run) => run.box)}
        imageNatural={{ w: SHEET_WIDTH, h: SHEET_HEIGHT }}
      />
    </>
  )
}
